enum AiProviderTypes {
  OpenAi = 'openai',
  Perplexity = 'perplexity'
}

export default AiProviderTypes;
